// Newsletter Popup

document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("PopupModal-welcome-popup");
    const form = popup ? popup.querySelector("form") : null;
    const closeButton = document.getElementById("ModalClose-welcome-popup");
    const overlayCloseButton = document.getElementById("ModalClose-welcome-popup-overlay");
    const welcomePopup = document.querySelector("welcome-popup"); // Select the modal element

    if (form) {
        form.addEventListener("submit", function (event) {
            event.preventDefault(); // Stop form from refreshing the page

            // Hide the form fields
            form.style.display = "none";

            // Remove any previous thank-you message
            const existingMessage = document.querySelector(".welcome-popup__thank-you");
            if (existingMessage) {
                existingMessage.remove();
            }

            // Create and display a Thank You message
            const thankYouMessage = document.createElement("p");
            thankYouMessage.textContent = window.welcome_popup_thankyou_text;
            thankYouMessage.classList.add("welcome-popup__thank-you");

            form.parentElement.appendChild(thankYouMessage);

            // Add class to the <welcome-popup> modal
            if (welcomePopup) {
                welcomePopup.classList.add("thank-you-visible");
            }
        });
    }
});


// Newsletter Popup End


// Function to open cart samples
// function openCartSamples() {
//   const cartSamplesElement = document.querySelector('cart-samples');
//   if (cartSamplesElement && typeof cartSamplesElement.open === 'function') {
//     setTimeout(() => {
//       cartSamplesElement.open();
//       console.log('Successfully opened cart-samples element');
//     }, 10);
//   }
// }

// function handleCartDrawerChange() {
//   setTimeout(function () { openCartSamples(); }, 1500);
//   setTimeout(function () { openCartSamples(); }, 2500);
// }

// document.addEventListener('DOMContentLoaded', function() {

//   openCartSamples();
//   // Select the element you want to monitor
//   const cartDrawer = document.querySelector('cart-drawer');

//   // Store the original open method
//   const originalCartDrawerOpen = cartDrawer.open;
  
//   // Replace the open method with your own implementation
//   cartDrawer.open = function(...args) {
//     // Call the original method with the original context and arguments
//     const result = originalCartDrawerOpen.apply(this, args);
    
//     // Call your function after the original open
//     openCartSamples();
    
//     // Return the result
//     return result;
//   };

// cartDrawer.addEventListener('change', () => handleCartDrawerChange());
// });












